import { JobApplication } from "../Entities/JobApplication";
import { JobDescriptionEntity } from "../Entities/JobDescription";

/**
 * Checks if an application is eligible for resume upload reminder.
 * An application is eligible if:
 * - Status is "applied"
 * - Job post is active
 * - Profile match status is pending, missing, or profile ID is missing
 */
export const isEligibleForResumeReminder = (
  application: JobApplication,
  jobPost: JobDescriptionEntity | undefined,
): boolean => {
  if (!jobPost) return false;

  return (
    application.status === "applied" &&
    jobPost.isActive &&
    (application.profileMatchStatus?.status === "pending" ||
      !application.profileMatchStatus ||
      !application.profileId)
  );
};
